import { Box, Switch, TextField, Typography } from "@mui/material";

const glassCard = { p: 2, borderRadius: 3, bgcolor: "rgba(255,255,255,0.7)", backdropFilter: "blur(8px)", border: "1px solid rgba(229,231,235,0.6)", boxShadow: "0 2px 12px rgba(0,0,0,0.04)" };

const LocationTab = ({ skipOption, setSkipOption, errorMessage, setErrorMessage, validations, setValidations }) => {
  return (
    <Box sx={{ mt: 1, display: "flex", flexDirection: "column", gap: 2 }}>
      <Box sx={glassCard}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Box>
            <Typography sx={{ fontWeight: 600, fontSize: 13, color: "#1f2937" }}>Skip Option</Typography>
            <Typography sx={{ fontSize: 11, color: "#6b7280" }}>Allow visitors to skip</Typography>
          </Box>
          <Switch checked={skipOption} onChange={(e) => setSkipOption(e.target.checked)} size="small" />
        </Box>
      </Box>

      <Box sx={glassCard}>
        <Typography sx={{ fontWeight: 600, fontSize: 13, mb: 1, color: "#1f2937" }}>Validation</Typography>
        <Box sx={{ display: "flex", gap: 2 }}>
          <TextField fullWidth label="Min Length" type="number" size="small"
            value={validations?.minLength ?? ""} onChange={(e) => setValidations({ ...validations, minLength: Number(e.target.value) || undefined })}
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2, bgcolor: "#fff", fontSize: 12 } }} />
          <TextField fullWidth label="Max Length" type="number" size="small"
            value={validations?.maxLength ?? ""} onChange={(e) => setValidations({ ...validations, maxLength: Number(e.target.value) || undefined })}
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2, bgcolor: "#fff", fontSize: 12 } }} />
        </Box>
      </Box>

      <Box sx={glassCard}>
        <Typography sx={{ fontWeight: 600, fontSize: 13, mb: 1, color: "#1f2937" }}>Error Message</Typography>
        <TextField fullWidth placeholder="Please enter a valid location" value={errorMessage} size="small"
          onChange={(e) => setErrorMessage(e.target.value)}
          sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2, bgcolor: "#fff", fontSize: 12 } }} />
      </Box>
    </Box>
  );
};

export default LocationTab;
